import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'
import { Container, Content, BottomBar, Section } from '../../modules';
import { Parametercategory, ParametercategoryFactory } from '../../resource/';
import { RouteComponentProps } from 'react-router';
import { IAuthProps, Query } from '../../services';

import { CategoryTree } from '../../controls/CategoryTree';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Message } from '@independent-software/typeui/controls/Message';
import { Placeholder } from '@independent-software/typeui/controls/Placeholder';

interface IState {
  parametercategories: Parametercategory[];
}

class ParametercategoryList extends React.Component<IAuthProps & RouteComponentProps<any>, IState> {
  constructor(props: IAuthProps & RouteComponentProps<any>) {
    super(props);

    this.state = {
      parametercategories: null
    };
  }

  componentDidMount = () => {
    // Retrieve a list of parametercategories:
    let query = new Query('name', 'asc');
    ParametercategoryFactory.getSome(this.props.auth, 0, 999, query)
      .then((res) => this.setState({ parametercategories: res.items }));
  }

  handleClick = (item: Parametercategory) => {
    this.props.history.push(`/parametercategories/${item.id}`);
  }

  handleAdd = (item: Parametercategory, name: string) => {
    let cat = ParametercategoryFactory.create();
    cat.parent = item ? item.id : null;
    cat.name = name;
    cat.$save(this.props.auth)
      .then(res => {
        ToastService.toast("Parameter category created.");
        cat.id = res.data;
        this.setState({
          parametercategories: [ ...this.state.parametercategories, cat ]
        });
      });
  }

  handleEdit = (item: Parametercategory, name: string) => {
    item.name = name;
    item.$update(this.props.auth)
      .then(res => {
        ToastService.toast("Parameter category updated.");
      });    
  }
  
  handleDelete = (item: Parametercategory) => {
    let idx = this.state.parametercategories.indexOf(item);
    this.state.parametercategories.splice(idx, 1);
    this.setState({
      parametercategories: this.state.parametercategories
    });
    item.$delete(this.props.auth)
      .then(res => {
        ToastService.toast("Parameter category deleted.");
      });        
  }

  render() {
    let p = this.props;
    return (
      <Container>
        <Content>
          <Section padded="very">
            {this.state.parametercategories == null && <>
              <Placeholder>
                <Placeholder.Header image>
                  <Placeholder.Line tall/>
                  <Placeholder.Line tall/>
                </Placeholder.Header>
              </Placeholder>
            </>}
            {this.state.parametercategories != null && 
              <>
                {this.state.parametercategories.length == 0 && 
                  <Message type="info">
                    No parameter categories have been defined yet.
                  </Message>}    
                <CategoryTree 
                  items={this.state.parametercategories} 
                  onClick={this.handleClick}
                  onAdd={p.auth.hasRight('can_edit_parametercategories') && this.handleAdd} 
                  onEdit={p.auth.hasRight('can_edit_parametercategories') && this.handleEdit} 
                  onDelete={p.auth.hasRight('can_delete_parametercategories') && this.handleDelete}
                  countfield="parameters_count"
                  />
              </>}
          </Section>
        </Content>
        <BottomBar>
        </BottomBar>

      </Container>
    );
  }
}

const IconHolder = styled('div')`
  padding-top: 2px;
`

const FloatButton = styled('div')`
  float: left;
`


export { ParametercategoryList };
